import { useState } from "react";
import { FiChevronLeft, FiEdit, FiTrash, FiUserPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ButtonComponent } from "../../components/Button";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import { Student, useUnitLesson } from "../../hooks/unitLesson";
import {
  ContainerButton,
  Content
} from "../../styles/components";
import { Empty, FormHeader, Header, ItemMarker, Legend } from "./styles";

export function AttendanceRecord() {
  const [studentToDelete, setStudentToDelete] = useState<Student | null>(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const { unitLesson, setUnitLesson } = useUnitLesson();
  const navigate = useNavigate();

  const handleSelect = (name: string): void => {
    const students = unitLesson?.students
      .map((i) => {
        return { ...i, present: i.name == name ? !i.present : i.present };
      });

    const unit = { ...unitLesson, students };
    setUnitLesson(unit);
  };

  const handleSubmit = () => {
    navigate("/informationRecord");
  };

  const handleEdit = (item: Student): void => {
    navigate(`/register/${item?.id ? item.id : item?.id_mocked}`)
  };

  const handleDelete = (item: Student): void => {
    setStudentToDelete(item);
    setShowConfirmDialog(true);
  };

  const confirmDelete = (): void => {
    if (studentToDelete) {
      const updatedStudents = unitLesson?.students.map((s) => {
        if(!studentToDelete?.id && s?.id_mocked == studentToDelete?.id_mocked)
          return { ...s, removed: true, present: false }

        if(studentToDelete?.id && s?.id == studentToDelete?.id)
          return { ...s, removed: true, present: false }

        return s
      });
      setUnitLesson({ 
        ...unitLesson,
        students: [...updatedStudents] 
      });
    }
    setShowConfirmDialog(false);
    setStudentToDelete(null);
  };

  return (
    <>
      <Header>
        <div>
          <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
            <div
              style={{
                gap: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FiChevronLeft />
              <label htmlFor="">Registro de presença</label>
            </div>

            <div style={{ display: "flex", gap: 8 }}>
              <span style={{ fontSize: 16 }}>
                Trimestre: {unitLesson.quarter}
              </span>
              <span style={{ fontSize: 16 }}>Lição: {unitLesson.number}</span>
            </div>
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/register")}
        >
          <FiUserPlus />
        </div>
      </Header>

      <Content>
        <FormHeader>
          <h2 style={{ fontSize: 18 }}>Alunos</h2>
          <div style={{ display: "flex", gap: 8 }}>
            <Legend primary={true}> Presente </Legend>
            <Legend> Faltou </Legend>
          </div>
        </FormHeader>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "opacity 0.6s"
          }}
        >
          <span style={{ fontSize: 14 }}>Selecione os alunos presentes </span>
          {unitLesson?.students.filter((i) => i.present).length > 0 && (
            <span>
              Membro(s) presente(s):{" "}
              <span>
                {unitLesson?.students.filter((i) => i.present).length}
              </span>{" "}
            </span>
          )}
        </div>

        {unitLesson?.students.filter(s => !s?.removed).map((i, index) => (
          <div 
            key={`${i.name}-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 4
            }}
          >
            <ItemMarker
              onClick={() => handleSelect(i?.name)}
              marked={i.present}
            >
              <label htmlFor={i.name}>{i.name.toLocaleUpperCase()}</label>
            </ItemMarker>
            <button 
              onClick={() => handleEdit(i)}
              style={{
                padding: 16,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: "#017AEA",
                color: '#FFF',
                borderRadius: 8,
                borderColor: 'transparent'
              }}
            >
              <FiEdit size={24}/>
            </button>

            <button 
              onClick={() => handleDelete(i)}
              style={{
                padding: 16,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: "#FF5500",
                color: '#FFF',
                borderRadius: 8,
                borderColor: 'transparent'
              }}
            >
              <FiTrash size={24}/>
            </button>
          </div>
        ))}

        {unitLesson?.students.length === 0 && (
          <Empty>
            <label htmlFor="">Não possui itens</label>
          </Empty>
        )}
      </Content>

      <ContainerButton>
        <ButtonComponent
          disabled={unitLesson?.students.filter((i) => i.present).length === 0}
          type="button"
          title="Continuar"
          onClick={handleSubmit}
        />
      </ContainerButton>

      {showConfirmDialog && (
        <ConfirmDialog
          message={`Deseja realmente remover o aluno "${studentToDelete?.name}"?`}
          onConfirm={confirmDelete}
          onCancel={() => {
            setShowConfirmDialog(false);
            setStudentToDelete(null);
          }}
        />
      )}
    </>
  );
}
